import { faLongArrowRight } from "@fortawesome/pro-light-svg-icons"
import { ListItem, Typography } from "@mui/material"
import { IQuickLink } from "./QuickLink.interfaces"
import { StyledFontAwesomeIcon, StyledLink } from "./QuickLink.styled"

export const QuickLink = ({ route, text }: IQuickLink) => {
  return (
    <ListItem disableGutters disablePadding>
      <StyledLink to={route}>
        <Typography color="textSecondary">{text}</Typography>
        <StyledFontAwesomeIcon icon={faLongArrowRight} />
      </StyledLink>
    </ListItem>
  )
}
